import { ApiTable } from "@/shared/api/table/api-table";
import { ApiFeedbacks } from "@/shared/api/feedbacks/api-feedbacks";
import { useServiceWorkflowStore } from "@/shared/stores/serviceWorkflowStore";
import { useUiStore } from "@/shared/stores/uiStore";

interface UseTableUnsubscribeProps {
  onUnsubscribeSuccess: () => void;
  showToast: (
    message: string,
    type: "success" | "error",
    duration?: number,
  ) => void;
}

export const useTableUnsubscribe = ({
  onUnsubscribeSuccess,
  showToast,
}: UseTableUnsubscribeProps) => {
  const { openModal } = useUiStore();
  const { serviceType: serviceTypeFromStore } = useServiceWorkflowStore();

  const confirmUnsubscribe = async (
    tableId: string,
    feedback: { question: string; answer: string }[],
    seriveTypeParam?: string,
  ) => {
    const serviceType = seriveTypeParam
      ? seriveTypeParam
      : serviceTypeFromStore;

    if (!serviceType) {
      const errorMsg = "Тип сервиса не определен.";
      showToast(errorMsg, "error", 4000);
      throw new Error(errorMsg);
    }

    try {
      const tableApi = new ApiTable();
      await tableApi.unsubscribeTable(tableId);

      const feedbacksApi = new ApiFeedbacks();
      await feedbacksApi.sendFeedbacks({
        feedback,
        data: {
          service_id: tableId,
          service_type: serviceType === "auto_table" ? "auto" : "jam",
        },
      });

      showToast("Подписка успешно отменена", "success", 4000);
      onUnsubscribeSuccess();
    } catch (error) {
      showToast("Ошибка отмены подписки", "error", 4000);
      throw error;
    }
  };

  const handleUnsubscribeRequest = (id: string, seriveTypeParam?: string) => {
    openModal("UNSUBSCRIBE_FLOW", {
      onConfirm: (feedback) =>
        confirmUnsubscribe(id, feedback, seriveTypeParam),
    });
  };

  return { handleUnsubscribeRequest };
};
